// app/src/screens/CreditsReturn.jsx — the Stripe Checkout return (D1-DESIGN §5.4). The WEBHOOK is
// the only writer; this page is UI sugar — poll the balance until it moves (~20s), then say so. A
// cancel return says nothing was charged. Never writes anything. D2a: on-brand Spectrum styling.

import React, { useEffect, useState } from 'react';
import { CircleDollarSign } from 'lucide-react';
import { navigate } from '@common/router.js';
import { useI18n } from '../i18n/index.jsx';
import { useSession } from '../lib/session.jsx';

export default function CreditsReturn() {
  const { t } = useI18n();
  const { refreshCredits } = useSession();
  const [msg, setMsg] = useState(null);
  const status = new URLSearchParams(window.location.search).get('status');

  useEffect(() => {
    if (status === 'cancel') { setMsg(t('credits.cancelled')); return; }
    let stopped = false;
    (async () => {
      setMsg(t('credits.checking'));
      const first = await refreshCredits();
      const start = first.kind === 'ok' ? first.body.balance : null;
      for (let i = 0; i < 10 && !stopped; i++) {
        await new Promise((r) => setTimeout(r, 2000));
        const now = await refreshCredits();
        if (now.kind === 'ok' && start != null && now.body.balance > start) {
          setMsg(t('credits.arrived', { balance: now.body.balance }));
          return;
        }
      }
      if (!stopped) setMsg(t('credits.pending'));
    })();
    return () => { stopped = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ maxInlineSize: 480, margin: '10vh auto 0' }}>
      <div className="q-card" style={{ padding: 24, boxShadow: 'var(--shadow-card)' }}>
        <div style={{ width: 48, height: 48, borderRadius: 999, background: 'var(--mint-tint)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
          <CircleDollarSign size={24} color="var(--mint)" strokeWidth={2} />
        </div>
        <p style={{ font: '500 16px/1.5 var(--font-body)', margin: '0 0 18px' }}>{msg || t('common.loading')}</p>
        <button className="q-btn press btn-ghost" onClick={() => navigate('/')}>{t('credits.returnBack')}</button>
      </div>
    </div>
  );
}
